const snack = require("../snack/snack");
const itemDt = require('../../applications/staff/desktop/entity/item/item-dt')
const itemFullcont = require('../../applications/staff/desktop/entity/item/item-fullcont')

const customerDt = require('../../applications/staff/desktop/entity/customer/customer-dt')
const customerFullcont = require('../../applications/staff/desktop/entity/customer/customer-fullcont')

const providerDt = require('../../applications/staff/desktop/entity/provider/provider-dt')
const providerFullcont = require('../../applications/staff/desktop/entity/provider/provider-fullcont')

async function DB(detail, phpFile) {
  try {
    const response = await fetch(phpFile, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(detail),
    });

    const result = await response.json();

    if (result.status !== "ok") {
      throw new Error(result.message || "Error desconocido");
    }

    return result;
  } catch (error) {
    //console.error("Error en la petición:", error);
    throw error;
  }
}

const entityMap = {
  item: itemDt,
  customer: customerDt,
  provider: providerDt,
};

const fullcontMap = {
  item: itemFullcont,
  customer: customerFullcont,
  provider: providerFullcont,
};

export function updateAvatar(detail, htmlFc, callback) {
  const entity = detail.entity;
  setTimeout(() => {
    const phpFile = "server/php/sql/dalle.php";

    DB(detail, phpFile)
      .then((result) => {
        const dtObj = entityMap[entity];
        const fcObj = fullcontMap[entity];

        if (dtObj && dtObj.start) dtObj.start({ dest: entity, elem: 'dt', act: 'select', entity });
        if (fcObj && fcObj.resetFullcont) fcObj.resetFullcont(detail, htmlFc);
      })
      .catch((error) => {
        throw error;
      });
  }, 1000);
}